import type { CISProviderBehavior } from '../types';

export const invoiceCloudCISBehavior: CISProviderBehavior = {
	label: 'InvoiceCloud',
	getTestPanelConfig() {
		return { show: true, altText: 'InvoiceCloud' };
	},
};
